import styled from "styled-components";

export const Container = styled.div`
  font-family: "Sora";
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #eff1f5;
  height: 100%;
  padding: 3.2rem 1.7rem 0 1.7rem;
  gap: 3rem;
`;

export const IterableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-right: 1.5rem;
`;
